<template>
  <div class="inside">
    <ul class="section-list">
      <li v-for="section in sections" :key="section.text.title.en">
        <!-- <h3 class="section-title">{{ section.text.title[currentLang] }}</h3> -->
      <br>
      <br>
      <br>
        <ul class="stop-list">
          <li
            v-for="stop in section.stops"
            :key="stop.text.title.en"
            class="stop-list__item"
          >
            <router-link
              :to="{ name: 'stop', params: { id: stop.id } }"
              class="stop-list__anchor"
            >
              <StopCard
                :modifier="`stop-card--list`"
                :image="stop.image"
                :title="stop.text.title[currentLang]"
                :stopNumber="stop.text.stopNumber[currentLang]"
              />
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import StopCard from "@/components/StopCard";
import { mapState } from "vuex";
export default {
  components: {
    StopCard
  },
  computed: {
    ...mapState(["stops", "sections", "currentLang"])
  },
  mounted() {
    document.body.classList.remove("no-scroll");
  },
  beforeDestroy() {
    document.body.classList.add("no-scroll");
  }
};
</script>

<style lang="scss" scoped>
.stop-list__anchor {
  text-decoration: none;
}
.section-list,
.stop-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.section-title {
  @include ngv-type($standard-heading, 24px, 27px);
  font-weight: normal;
  margin-top: 70px;
  margin-bottom: 40px;
}
</style>
